export const MODES = {
	EDIT: 'EDIT',
	NEW: 'NEW',
};
